import { fragSamplerTint } from '../shaders/frag-sampler-tint.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { RegionMask } from './components/regionMasks/regionMask';
import { TexturePipelineBase } from './pipeline-texBase';
import { TintUniformData } from './pipeline-tinting';
import { PipelineGlUtils } from './utils/pipeline-utils-gl';

export class TintedTexturePipeline extends TexturePipelineBase {
  public constructor(regionMaskColour = '') {
    super(vertSampler, fragSamplerTint);

    if (regionMaskColour) {
      this.regionMask = new RegionMask();
      this.fragShader = RegionMask.ModifyFragShaderText(this.fragShader, regionMaskColour);
      // console.log(`Region mask component added. Revised frag shader:`, this.fragShader);
    }
  }

  protected InitShaderProps(shaderProgram: WebGLProgram) {
    super.InitShaderProps(shaderProgram);

    this.shaderProgramProps.u_tintColour = PipelineGlUtils.GetUniformLocation(this.gl, shaderProgram, 'uTintColour');

    this.regionMask?.GetProgramProps(this.gl, this.shaderProgramProps, shaderProgram);
  }

  // Exists just for "uniformData" type extension.
  public Draw(uniformData: TintUniformData): void {
    super.Draw(uniformData);
  }

  // Exists just for "uniformData" type extension.
  public DrawOnceForPixelData(uniformData: TintUniformData): Uint8Array {
    return super.DrawOnceForPixelData(uniformData);
  }

  protected SetUniforms(tintColour: TintUniformData) {
    super.SetUniforms({});
    this.gl.uniform3fv(this.shaderProgramProps.u_tintColour, tintColour);

    // Using "this.glTextures.length" should accurately presume that the region mask texture is the only one that falls in line behind the main set of textures.
    // ! This is only particularly true for now... won't hold up for long if more components need to be made.
    this.regionMask?.SetUniforms(this.gl, this.glTextures.length, this.shaderProgramProps);
  }
}
